import { Helmet } from 'react-helmet-async'
import { useCatalogStats } from '../hooks/useCatalogStats'

import CurationDiscipline from '../components/home/CurationDiscipline'
import FeaturedStrip from '../components/home/FeaturedStrip'
import FinalCTA from '../components/home/FinalCTA'
import Hero from '../components/home/Hero'
import NewsletterCapture from '../components/home/NewsletterCapture'
import ProductivityGuideFeature from '../components/home/ProductivityGuideFeature'
import SubmitInvite from '../components/home/SubmitInvite'
import WizardDemo from '../components/home/WizardDemo'
import StudentHubShowcase from '../components/home/StudentHubShowcase'

export default function HomePage() {
  const { roundedToolsText } = useCatalogStats() // {/* Dynamic — do not hardcode */}

  return (
    <>
      <Helmet>
        <title>{`AI Tools for Students — ${roundedToolsText} Checked, Free Tiers Explained | AI Compass`}{/* Dynamic — do not hardcode */}</title>
        <meta name="description" content={`${roundedToolsText} AI tools for students, each checked by a person and listed with its real free-tier limits. Writing, coding, research, design. No login needed.`} /* Dynamic — do not hardcode */ />
        <meta property="og:title" content={`AI Tools for Students — ${roundedToolsText} Checked, Free Tiers Explained | AI Compass`} /* Dynamic — do not hardcode */ />
        <meta property="og:description" content={`${roundedToolsText} AI tools for students, each checked by a person and listed with its real free-tier limits. Writing, coding, research, design. No login needed.`} /* Dynamic — do not hardcode */ />
        {/* Canonical is emitted server-side (index.html default, rewritten
            per-route by _inject_meta) to avoid a duplicate <link> tag. */}
      </Helmet>

      {/* Removed from the homepage on 2026-10-11: StatsShowcase (it served a
          hand-typed fallback as "verified metrics", and charted a decline) and
          CommunityShowcase (an empty feed reads as an abandoned site). Bring the
          feed back once the community has real activity. */}
      <Hero />
      <FeaturedStrip />
      <WizardDemo />
      <ProductivityGuideFeature />
      <StudentHubShowcase />
      <CurationDiscipline />
      <NewsletterCapture />
      <FinalCTA />
      <SubmitInvite />
    </>
  )
}
